export default "__VITE_ASSET__DPy38YWC__"